import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, PRICE_LABEL, packageGroups } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-slate-50 relative" data-id="element-165" data-mp="1ja0eo2sldvlt">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-166" data-mp="1nasniuxjxyhk">
        <div className="text-center mb-10" data-id="element-167" data-mp="1naam7jw18u2s">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-blue-950" data-id="element-168" data-mp="1s93zpcbbkl2y">
            Your complete <span className="text-amber-600" data-id="element-169" data-mp="1x86w68d8hizb">Olympic Weightlifting Coach Ready</span>{' '}
            package
          </h2>
          <p className="text-blue-950/75 text-sm md:text-base" data-id="element-170" data-mp="226i42djyxjew">
            The Complete 6-in-1 Visual Coaching System — Ready for Your Next Training Session
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-blue-950 border-2 border-amber-500 rounded-3xl p-1 relative shadow-xl shadow-blue-700/15" data-id="element-171" data-mp="7t0fqobqoiit">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-blue-950 font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-172" data-mp="1cr4vq5a21fph">
            <Sparkles size={14} data-id="element-173" data-mp="25d6ewgqomhs7" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-174" data-mp="20hqzvlgxufu7">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-blue-950 mb-3" data-id="element-175" data-mp="1vgl5lj7mqkik">
              Olympic Weightlifting Coach Ready —{' '}
              <span className="text-amber-600" data-id="element-176" data-mp="1rhu7b8rfgwtv">6-in-1 Visual Coaching System</span>
            </h3>

            <div className="text-left max-w-md mx-auto mb-6 bg-slate-50 border border-amber-500/40 rounded-xl p-4 space-y-5" data-id="element-177" data-mp="k03bhpri8tz3">
              {packageGroups.map(group => <div key={group.label} data-id="element-178" data-mp="hib1fnlu49oi">
                  <p className="text-sm font-bold text-blue-950 uppercase tracking-wider mb-2" data-id="element-179" data-mp="mgumllslthft">
                    {group.label}
                  </p>
                  <ul className="space-y-2" data-id="element-180" data-mp="7isj1blkovyk">
                    {group.items.map(item => <li key={item.label} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-181" data-mp="chdiv9wwxdmh">
                        {item.kind === 'bonus' ? <Gift size={16} className="text-blue-700 shrink-0 mt-0.5" data-id="element-182" data-mp="3hqhup83i9ty" /> : <Check size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-183" data-mp="3kz06t69oldcl" />}
                        <span data-id="element-184" data-mp="3pymn5okt39pm">{item.label}</span>
                      </li>)}
                  </ul>
                </div>)}
            </div>

            <div className="mb-6" data-id="element-185" data-mp="3fz5fj1lzulr0">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-186" data-mp="3fy3wa9utqsy7">
                <span className="text-2xl md:text-3xl text-blue-950/75" data-id="element-187" data-mp="2xc4px7gm1g1r">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-blue-950" data-id="element-188" data-mp="2scjo8pa22tlc">{PRICE_LABEL}</span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-189" data-mp="36dco7pj4mgvu">
              🟠 GET OLYMPIC WEIGHTLIFTING COACH READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500 mb-4" data-id="element-190" data-mp="3bbnw3upv2hbf">
              <span className="flex items-center gap-1.5" data-id="element-191" data-mp="3p17ukocessex">
                <Lock size={12} className="text-blue-700" data-id="element-192" data-mp="3l0nylo3knuud" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-193" data-mp="3l31t9vucb51e">
                <Zap size={12} className="text-blue-700" data-id="element-194" data-mp="2vudnabyyvrq" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-195" data-mp="3u2oscazljyra">
                <Check size={12} className="text-blue-700" data-id="element-196" data-mp="hycbelb5265f" /> Complete Digital PDF Bundle
              </span>
            </div>

            <div className="bg-slate-50 border border-amber-500/40 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-197" data-mp="lymk45qbfanz">
              <Globe className="text-blue-950 shrink-0 mt-0.5" size={14} data-id="element-198" data-mp="qshatt4c8pwk" />
              <p className="text-[11px] text-slate-500 leading-snug" data-id="element-199" data-mp="vo65bi1i3gm0">
                🌍 Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}